import { http } from "@/lib/http";

import type {
  ContainerCreateRequest,
  OrderCreateRequest,
  Secret,
  SecretContainer,
  SecretCreateRequest,
  SecretOrder,
  SecretPayload,
} from "./types";

export async function listSecrets(): Promise<Secret[]> {
  const { data } = await http.get<Secret[]>("/secrets");
  return data;
}

export async function createSecret(
  payload: SecretCreateRequest,
): Promise<Secret> {
  const { data } = await http.post<Secret>("/secrets", payload);
  return data;
}

export async function revealSecret(secretId: string): Promise<SecretPayload> {
  const { data } = await http.get<SecretPayload>(
    `/secrets/${secretId}/payload`,
  );
  return data;
}

export async function deleteSecret(secretId: string): Promise<void> {
  await http.delete(`/secrets/${secretId}`);
}

// --- Containers ---

export async function listContainers(): Promise<SecretContainer[]> {
  const { data } = await http.get<SecretContainer[]>("/secrets/containers");
  return data;
}

export async function createContainer(
  payload: ContainerCreateRequest,
): Promise<SecretContainer> {
  const { data } = await http.post<SecretContainer>(
    "/secrets/containers",
    payload,
  );
  return data;
}

export async function deleteContainer(containerId: string): Promise<void> {
  await http.delete(`/secrets/containers/${containerId}`);
}

// --- Orders ---

export async function listOrders(): Promise<SecretOrder[]> {
  const { data } = await http.get<SecretOrder[]>("/secrets/orders");
  return data;
}

export async function createOrder(
  payload: OrderCreateRequest,
): Promise<SecretOrder> {
  const { data } = await http.post<SecretOrder>("/secrets/orders", payload);
  return data;
}

export async function deleteOrder(orderId: string): Promise<void> {
  await http.delete(`/secrets/orders/${orderId}`);
}
